import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lastAlertTime: null,
};

const soundAlertSlice = createSlice({
  name: "soundAlert",
  initialState,
  reducers: {
    setLastAlertTime: (state, action) => {
      state.lastAlertTime = action.payload; 
    },
  },
});

export const { setLastAlertTime } = soundAlertSlice.actions;
export default soundAlertSlice.reducer;
